<template>
    <nav class="menu">
        <template v-if="groupedCategories">
            <h4 class="menu__caption">
                <span class="material-icon icon-format_list_bulleted"></span>
                {{ $t('album_categories') }}
            </h4>
            <ul v-if="groupedCategories.length > 0" class="menu__wrap-list">
                <li v-for="(category, catIndex) in groupedCategories" :key="catIndex" class="menu__wrap-item">
                    <a href="#" class="" @click.prevent="" v-b-toggle="`collapse-${catIndex}`">
                        <span class="material-icon icon-keyboard_arrow_right"></span>
                        {{ category.title }}
                        <span class="menu__counter">({{ category.total_count || 0 }})</span>
                    </a>
                    <b-collapse v-if="category.years && category.years.length > 0" :id="`collapse-${catIndex}`" :visible="category.id === $route.params.categoryId">
                        <ul class="menu__list">
                            <li v-for="(item, i) in category.years" :key="i" class="menu__item" :class="{'menu__item--active': category.id === $route.params.categoryId && item.album_year === $route.params.year}">
                                <router-link :to="i18nLink(`album/category/${category.id}/${item.album_year}`)">
                                    {{ item.album_year }}
                                    <span class="menu__counter">({{ item.album_year_count }})</span>
                                </router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </li>
            </ul>
            <div v-else class="alert alert-info">{{ $t('no_data') }}</div>
        </template>
        <div v-else>{{ $tc('loading', 2) }}</div>
    </nav>
</template>

<script>
  import menuAlbumCategories from 'src/mixins/menuAlbumCategoriesComponent';

  export default {
    mixins: [menuAlbumCategories],
  };
</script>